import { render, staticRenderFns } from "./OptionEnd.vue?vue&type=template&id=1d530d6e&"
import script from "./OptionEnd.vue?vue&type=script&lang=js&"
export * from "./OptionEnd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports